const Constant = {};

Constant.COMMENT_TYPE = {
  NORMAL: "0",
  JOIN: "1",
  LEAVE: "2",
};
Constant.COLORS = [
  {
    name: "黒",
    code: "#000000",
  },
  {
    name: "赤",
    code: "#FF0000",
  },
  {
    name: "青",
    code: "#0000FF",
  },
  {
    name: "緑",
    code: "#119911",
  },
  {
    name: "茶",
    code: "#900000",
  },
  {
    name: "紫",
    code: "#C000C0",
  },
  {
    name: "ピンク",
    code: "#FF00FF",
  },
  {
    name: "オレンジ",
    code: "#FF8040",
  },
];

export default Constant;
